<template>

  <div v-if="userData">
    <section id="card-actions">
      <b-row>
        <!-- card actions -->
        <b-col cols="12">
          <b-card no-body>
            <div
              class="card-header"
            >
              <!-- Title & SubTitle -->
              <div>
                <b-card-title>{{ $t('User information') }}</b-card-title>
              </div>

              <!-- Card Actions -->
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      v-if="canUpdate()"
                      v-b-toggle.sidebar-update-user
                      data-action="collapse"
                      :title="$t('Update')"
                    >
                      <feather-icon
                        icon="EditIcon"
                        size="16"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <b-card-body>
              <b-row>
                <b-col cols="12">
                  <b-table
                    responsive
                    :items="userDetails"
                    :fields="fields"
                    primary-key="id"
                    class="position-relative"
                    bordered
                  >
                    <template #head()="data">
                      {{ $t(data.label) }}
                    </template>
                    <template
                      #cell(id)=""
                      class="text-center"
                    >
                      {{ "data.INFO" }}
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <update
      ref="update-user"
      @refetchData="refetchData"
    />
  </div>

</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BTable, BCard, BCardTitle, BCardBody, VBToggle,
} from 'bootstrap-vue'
import store from '@/store'
import userModule from '@/store/user/index'
import Update from './Update.vue'

export default {

  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardTitle,
    BCardBody,
    Update,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        { key: 'TYPE', label: 'Info type' },
        { key: 'INFO', label: 'Info' },
      ],
      isUserMe: false,
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    userData() {
      return this.$store.state.user.user.data
    },

    userDetails() {
      let fields = [
        { key: 'full_name', label: 'Full name' },
        { key: 'email', label: 'Email' },
        { key: 'role_id', label: 'Role' },
        { key: 'org_id', label: 'Organization' },
        { key: 'birth_date', label: 'Birthday' },
        { key: 'birth_place', label: 'Birth place' },
        { key: 'ctzn', label: 'Citizenship' },
        { key: 'mob_phone_no', label: 'Mobile phone' },
        { key: 'natn', label: 'Nationality' },
        { key: 'per_adr', label: 'Permanent address' },
        { key: 'pin', label: 'PNFL' },
        { key: 'pport_issue_place', label: 'Who issued the passport' },
        { key: 'pport_no', label: 'Passport series and number' },
        { key: 'tin', label: 'Tin' },
      ]
      const removeFieldForForeign = ['pin', 'tin']
      if (this.isForeignUser()) fields = fields.filter(x => (!removeFieldForForeign.includes(x.key)))
      return fields.map(field => ({ TYPE: this.$t(field.label), INFO: this.getFieldValue(field.key, this.userData[field.key]) }))
    },
  },
  created() {
    this.isUserMe = false
    if (this.$route.params.id) this.$store.dispatch('user/user', this.$route.params.id)
    else {
      this.isUserMe = true
      this.$store.dispatch('user/me')
    }
    this.$store.dispatch('staticModule/role')
  },
  methods: {
    getFieldValue(field, value) {
      if (field === 'role_id') {
        return this.$langName(this.getUserRole(value).name)
      }
      if (field === 'org_id') {
        if (!value) {
          return 'None'
        }
        return this.$langName(value.name)
      }
      return value
    },
    isForeignUser() {
      return this.userData.user_type === this.$store.state.staticModule.userTypeForeign
    },
    canUpdate() {
      return this.isForeignUser() && this.isUserMe
    },
    getUserRole(id) {
      return this.$store.getters['staticModule/getUserRole'](id)
    },
    // stop refreshing card in 3 sec
    refreshStop(cardName) {
      setTimeout(() => {
        this.$refs[cardName].showLoading = false
      }, 3000)
    },
    refetchData() {
      this.$store.commit(`${this.MODULE_USER}/FRESH`)
      this.isUserMe = false
      if (this.$route.params.id) this.$store.dispatch('user/user', this.$route.params.id)
      else {
        this.isUserMe = true
        this.$store.dispatch('user/me')
      }
    },
  },
  setup() {
    const MODULE_USER = 'user'

    // Register module
    if (!store.hasModule(MODULE_USER)) store.registerModule(MODULE_USER, userModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_USER)) store.unregisterModule(MODULE_USER)
    })
    return {
      MODULE_USER,
    }
  },
}
</script>

<style>

</style>
